import {Pipe, PipeTransform} from '@angular/core';
import {SelectItemHelper} from '../enums/select-item-helper';
import {SelectItemService} from '../services/select-item.service';

@Pipe({ name: 'dominio'})
export class DominioPipe implements PipeTransform {
  constructor(
    private selectItemService: SelectItemService
  ) {
  }
  transform(value: any, ...args: any[]): any {
    const method = args[0];

    if (this.selectItemService[method]) {
      const tipo = this.selectItemService[method]();
      return SelectItemHelper.getLabelSI(tipo, value);
    }
    else {
      console.error(`O método '${method}' não encontrado. Verificar se o método existe na classe SelectItemService`);
    }
  }
}
